import { getSpApi } from "./apiRoot";
import { UrlManager } from "./UrlManager";

// Swagger: https://ibpcsrcdev01.portima.net/mybrokerapi/swagger/index.html

export const getIncidentMessage = async (): Promise<MyBrokerApi.IncidentMessage[]> => {
    const { data } = await getSpApi().get<MyBrokerApi.IncidentMessage[]>(UrlManager.incidentMessage());
    return data;
};
